<template>
  <div class="template_viewer_modal" v-if="viewer.open" @click.self="close">
    <section class="template_viewer_container">
      <header class="template_viewer_header">
        <div class="header_text">
          <div class="header_title">
            <h3>{{ typeLabel }}</h3>
            <span class="template_name" v-if="viewer.templateName">{{ viewer.templateName }}</span>
          </div>
          <!-- 상품 템플릿 변경 화면으로 오해 방지용 역할 안내 -->
          <p class="header_guide">
            템플릿 자체의 설정을 수정하는 화면입니다.<br />
            상품에 적용된 템플릿을 변경하려면 <strong>상품 수정(✎) &gt; 기본정보</strong>에서 변경해주세요.
          </p>
        </div>
        <div class="header_actions">
          <a class="page_link" :href="pageUrl" target="_blank" rel="noopener noreferrer">
            전체 화면으로 열기
          </a>
          <button type="button" class="close_button" @click="close" aria-label="닫기">✕</button>
        </div>
      </header>

      <!-- 단어설정 템플릿 스타일은 페이지 루트(.word_template) 하위로 작성돼 있어 클래스를 붙여준다 -->
      <div class="template_viewer_body" :class="{ word_template: viewer.type === 'word' }">
        <component
          v-if="editorComponent"
          :is="editorComponent"
          :key="viewer.type + '_' + viewer.templateId"
          :embedded="true"
          :presetTemplateId="viewer.templateId"
        />
        <p class="no_template_type" v-else>지원하지 않는 템플릿 종류입니다.</p>
      </div>
    </section>
  </div>
</template>

<script>
// 상품/단어설정/마진 템플릿을 어느 화면에서든 팝업으로 조회·수정하기 위한 공용 모달.
// 각 템플릿 페이지를 embedded 모드로 그대로 재사용한다. (별도 편집 UI를 중복 구현하지 않는다)
const TYPE_META = {
  image: { label: '상품 템플릿', url: '/app/template/image' },
  word: { label: '단어설정 템플릿', url: '/app/template/word' },
  upload: { label: '마진 템플릿', url: '/app/template/upload' }
};

export default {
  name: 'TemplateViewerModal',
  computed: {
    viewer() {
      return this.templateStore.viewer;
    },
    typeLabel() {
      return TYPE_META[this.viewer.type]?.label ?? '템플릿';
    },
    pageUrl() {
      return TYPE_META[this.viewer.type]?.url ?? '/app/template/image';
    },
    editorComponent() {
      switch (this.viewer.type) {
        case 'image':
          return () => import('@/views/app/template/image/index.vue');
        case 'word':
          return () => import('@/views/app/template/word/components/WordSetting.vue');
        case 'upload':
          return () => import('@/views/app/template/upload/index.vue');
        default:
          return null;
      }
    }
  },
  methods: {
    close() {
      this.templateStore.closeTemplateViewer();
    },
    onKeydown(event) {
      if (event.key === 'Escape' && this.viewer.open) this.close();
    }
  },
  mounted() {
    document.addEventListener('keydown', this.onKeydown);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.onKeydown);
  }
};
</script>

<style lang="scss">
@import '@/assets/style/common/templateViewer.scss';
</style>
